import { Badge } from '@/components/ui/badge.jsx';
import { cn } from '@/lib/utils.js';
import { usePeekStore } from '@/stores/peek-store.js';
import { openCarrierPeek } from '@/lib/links.js';

// Renders one carrier's state in a deal card.
// Backend emits state ∈ { not_submitted, submitted, awaiting, discussing,
// revised, presented, received, selected, declined } plus optional
// sub_state / age_label / decline_reason. This component maps state to
// the spec §3 visual vocab; full interactive popover comes in Step 7.

const STATE_VARIANT = {
  not_submitted: 'dashed',
  submitted: 'info',
  awaiting: 'warning',
  discussing: 'info',
  revised: 'accent',
  presented: 'info',
  received: 'success',
  selected: 'accent',
  declined: 'muted',
};

export default function CarrierBadge({ carrier }) {
  const openPeek = usePeekStore((s) => s.openPeek);
  if (!carrier) return null;
  const variant = STATE_VARIANT[carrier.state] || 'default';
  const subline = carrier.sub_state || carrier.decline_reason || carrier.age_label || null;
  const clickable = !!carrier.vendor_id;
  return (
    <Badge
      variant={variant}
      className={cn('gap-1', clickable && 'cursor-pointer hover:ring-1 hover:ring-accent/40')}
      role={clickable ? 'button' : undefined}
      tabIndex={clickable ? 0 : undefined}
      onClick={clickable ? (e) => { e.stopPropagation(); e.preventDefault(); openPeek(openCarrierPeek(carrier.vendor_id)); } : undefined}
      onKeyDown={clickable ? (e) => { if (e.key === 'Enter') { e.stopPropagation(); e.preventDefault(); openPeek(openCarrierPeek(carrier.vendor_id)); } } : undefined}
    >
      <span className={cn('text-[10px] font-semibold uppercase tracking-wide')}>
        {carrier.carrier_name || carrier.carrier_slug}
      </span>
      {subline ? (
        <span className="text-[10px] font-normal opacity-80">{subline}</span>
      ) : null}
    </Badge>
  );
}
